<template>
    <v-menu
            ref="menu1"
            :close-on-content-click="false"
            v-model="menu1"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                    slot="activator"
                    v-model="value"
                    :label="label"
                    :rules="rules"
                    :hint="hint"
                    persistent-hint
                    @blur="date = parseDate(value)"
                    outlined
                    readonly
                    v-bind="attrs"
                    v-on="on"
            ></v-text-field>
        </template>
        <v-date-picker
                v-model="date"
                no-title
                @input="menu1 = false"
                ref="picker"
                locale="sl-SI"
                min="1910-01-01"
                :max="maxYear"
        ></v-date-picker>
    </v-menu>
</template>

<script>
    export default {
        name: "DatePicker",
        props: {
            label: {
                type: String
            },
            value: {
                type: String
            },
            rules: {
                default: []
            },
            hint: {
                type: String,
                default: 'Vnesite datum v obliki dan.mesec.leto. Primer: 1.1.1975'
            },
            min_years: {
                type: Number,
                default: 15
            }
        },
        data: vm => ({
            date: '1990-01-01',
            menu1: false,
        }),
        computed: {
          maxYear() {
            if (this.min_years || this.min_years == 0) {
              return new Date(new Date().getFullYear() - this.min_years, new Date().getMonth(), new Date().getDate() + 1).toISOString().substr(0, 10);
            }
            return "" + (new Date().getFullYear() + 15);
          }
        },
        watch: {
            date(val) {
                this.value = this.formatDate(this.date)
            },
            menu1(val) {
                val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
            },
            value() {
                this.$emit('input', this.value);
            }
        },
        methods: {
            formatDate(date) {
                if (!date) return null
                const [year, month, day] = date.split('-')
                return `${day}.${month}.${year}`
            },
            parseDate(date) {
                if (!date) return null
                const [month, day, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
        }
    }
</script>

<style scoped>

</style>